<template>
<div class="badge text-white" :class="variant">
    {{ priority }}
</div>
</template>

<script>
import Vue from 'vue'
import { priorityVariant, priorityStr } from '@/constants/priorityType'
export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    computed: {
        priority() {
            return priorityStr.get(this.row.priority)
        },
        variant() {
            return 'badge-'+priorityVariant(this.row.priority)
        }
    }
})
</script>

<style>

</style>